<template>
    <div class="copy-catalog-response">
        <div class="copy-catalog-response-table overflow-x-auto scrollbar-hide">
            <!-- title -->
            <div class="text-xl font-semibold mb-4 dark:text-gray-100 text-gray-900">
                Copy Items Response
            </div>
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50 dark:bg-gray-600 dark:text-gray-100 text-gray-900">
                    <tr>
                        <th scope="col"
                            class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider dark:text-gray-100 text-gray-900">
                            From Store
                        </th>
                        <th scope="col"
                            class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider dark:text-gray-100 text-gray-900">
                            To Store
                        </th>
                        <th scope="col"
                            class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider dark:text-gray-100 text-gray-900">
                            Message
                        </th>
                        <th scope="col"
                            class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider dark:text-gray-100 text-gray-900">
                            Status
                        </th>
                        <th scope="col"
                            class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider dark:text-gray-100 text-gray-900">
                            Type
                        </th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200 dark:bg-gray-900 dark:text-gray-300">
                    <tr v-for="(item, index) in copyItemsResponse" :key="index">
                        <td class="px-6 py-4 whitespace-nowrap text-xs">
                            {{ item.copy_details.from_store.name }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-xs">
                            {{ item.copy_details.to_store.name }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-xs">
                            {{ item.message }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-xs">
                            {{ item.status }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-xs">
                            {{ item.type }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        copyItemsResponse: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.copy-catalog-response {
    &-table {
        &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
        }
        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 0px;
        }
        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 0px;
        }
    }
}
</style>